<template>
  <div class="app-container">
    <el-card>
      <div slot="header">
        <span><i class="el-icon-s-tools"></i> 维修记录</span>
      </div>

      <!-- Tabs -->
      <!-- 0:待分配，1：待维修 2：已维修 3：已取消，4：无法维修 -->
      <el-tabs v-model="state" @tab-click="handleTabChange">
        <el-tab-pane
          v-for="item in stateArr"
          :key="item.key"
          :label="item.label"
          :name="item.name"
        />
      </el-tabs>

      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        label-position="right"
        label-width="70px"
        class="query-form"
        style="margin-bottom: 20px"
      >
        <el-row :gutter="20">
          <!-- 报修部门 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="报修部门">
              <el-select
                v-model="queryParams.departmentId"
                placeholder="请选择报修部门"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in departmentList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <!-- 报修人 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="报修人">
              <el-input
                v-model="queryParams.creatorName"
                placeholder="请输入报修人"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>

          <!-- 报修时间 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="报修时间">
              <el-date-picker
                v-model="queryParams.reportTime"
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 按钮区域 -->
        <div>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
          >
            搜索
          </el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button @click="handleExport">导出</el-button>
        </div>
      </el-form>

      <!-- 表格区域 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column
          prop="departmentName"
          label="报修部门"
          width="120"
          fixed
        />
        <el-table-column prop="creatorName" label="报修人" width="100" fixed />
        <el-table-column label="故障类型" width="100" fixed>
          <template slot-scope="scope">
            {{
              scope.row.type === 1
                ? "物资报修"
                : scope.row.type === 2
                ? "故障报修"
                : "--"
            }}
          </template>
        </el-table-column>
        <el-table-column prop="location" label="故障位置" width="150" />
        <el-table-column prop="state" label="状态" width="100">
          <template slot-scope="scope">
            {{ formatState(scope.row.state) }}
          </template>
        </el-table-column>
        <el-table-column label="现场图片" width="120">
          <template slot-scope="scope">
            <div
              v-if="scope.row.attachments && scope.row.attachments.length > 0"
            >
              <ImagePreviewList :images="scope.row.attachments" />
            </div>
            <div v-else class="no-image-text">-- 暂无图片 --</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="故障描述"
          min-width="180"
          show-overflow-tooltip
        />
        <el-table-column prop="urgencyLevel" label="紧急程度" width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.urgencyLevel === 1">紧急</span>
            <span v-else-if="scope.row.urgencyLevel === 2">一般</span>
            <span v-else-if="scope.row.urgencyLevel === 3">轻微</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="handlerName" label="维修人" width="100" />
        <el-table-column
          prop="repairState"
          label="维修结果"
          min-width="150"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ formatRepairState(scope.row.repairState) }}
          </template>
        </el-table-column>

        <el-table-column label="维修结果图片" width="120">
          <template slot-scope="scope">
            <div
              v-if="
                Array.isArray(scope.row.repairAttachments) &&
                scope.row.repairAttachments.length
              "
            >
              <ImagePreviewList :images="scope.row.repairAttachments" />
            </div>
            <div v-else class="no-image-text">-- 暂无图片 --</div>
          </template>
        </el-table-column>
        <el-table-column prop="handleTime" label="维修时间" width="160" />
        <el-table-column prop="createTime" label="报修时间" width="160" />
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />
    </el-card>
  </div>
</template>

<script>
import { assetsRepairPage, assetsRepairExport } from "@/api/repair";
import ImagePreviewList from "@/components/ImagePreviewList/index";
import PaginationBar from "@/components/PaginationBar";
import { downloadFile, parseDateRange } from "@/utils/util";
import { mapState } from "vuex";

export default {
  name: "MaintenanceRecord",
  components: {
    ImagePreviewList,
    PaginationBar,
  },
  computed: {
    ...mapState(["departmentList"]), // 从 Vuex 获取 userPermissions
  },
  data() {
    return {
      selectedRows: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      queryParams: {
        reportTime: [],
        creatorName: "",
        departmentId: "",
      },
      state: "all", // 0:待分配，1：待维修 2：已维修 3：已取消，4：无法维修
      tableData: [],
      stateArr: [
        { label: "全部", name: "all", key: "all" },
        { label: "待分配", name: "0", key: "0" },
        { label: "待维修", name: "1", key: "1" },
        { label: "已维修", name: "2", key: "2" },
        { label: "已取消", name: "3", key: "3" },
        { label: "无法维修", name: "4", key: "4" },
      ],
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    formatRepairState(state) {
      const statusMap = {
        0: "待维修",
        1: "已维修",
        2: "无法维修",
      };

      return statusMap[state] || "--";
    },
    formatState(state) {
      const statusMap = {
        0: "待分配",
        1: "待维修",
        2: "已维修",
        3: "已取消",
        4: "无法维修",
      };
      return statusMap[state] || "--";
    },
    handleTabChange(tab) {
      this.state = tab.name; // 更新状态值
      this.currentPage = 1; // 切换状态时重置分页页码
      this.handleQuery();
    },
    handleQuery(page) {
      const { begin_date, end_date } = parseDateRange(
        this.queryParams.reportTime
      );
      this.currentPage = page || 1;
      assetsRepairPage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        startCreateTime: begin_date,
        endCreateTime: end_date,
        creatorName: this.queryParams.creatorName,
        departmentId: this.queryParams.departmentId,
        state: this.state === "all" ? "" : this.state,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams = {
        reportTime: [],
        creatorName: "",
        departmentId: "",
      };
      this.currentPage = 1;
      this.handleQuery();
    },
    handleExport() {
      const exportData = this.tableData || [];

      if (exportData.length === 0) {
        return this.$message.warning("暂无数据可以导出");
      }
      const { begin_date, end_date } = parseDateRange(
        this.queryParams.reportTime
      );
      assetsRepairExport({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        startCreateTime: begin_date,
        endCreateTime: end_date,
        creatorName: this.queryParams.creatorName,
        departmentId: this.queryParams.departmentId,
        state: this.state === "all" ? "" : this.state,
      }).then((res) => {
        downloadFile(
          res.data,
          "维修列表.xlsx",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        );
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
}
.el-image {
  cursor: pointer;
}
.el-form-item__content {
  width: 100%;
}
</style>
